import { getApi } from '../../config/SwaggerApi';
import { useQuery, UseQueryOptions } from 'react-query';
import qs from 'qs';
import { configQueryReactSimpleRequest } from '../../Hooks';

const fetchSecurity = (moduleName: string) =>
    getApi()
        .security.securityGetGet(
            { ModuleName: [moduleName] },
            {
                paramsSerializer: (params) => {
                    return qs.stringify(params, { arrayFormat: 'repeat' });
                },
            },
        )
        .then((response) => response.data);

const useSecurityQuery = (moduleName: string, queryOptions?: UseQueryOptions) => {
    //@ts-ignore
    const securityQuery = useQuery(['security', moduleName], () => fetchSecurity(moduleName), {
        ...configQueryReactSimpleRequest,
    });

    return securityQuery;
};

export default useSecurityQuery;
